var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMujeresAdultas = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "87px",
    height: "87px",
    viewBox: "0 0 87 87",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Salida-datos",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "inicio-selecci\\xF3n-multiple-de-eventos-copy-19",
    transform: "translate(-771.000000, -393.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(771.000000, 393.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-11",
    fill: "#6BC33C",
    opacity: 0.74546596,
    cx: 43.5,
    cy: 43.5,
    r: 43.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.999636,25 C47.30855,25 50,22.5329872 50,19.5 C50,16.4670128 47.30855,14 43.999636,14 C40.6905764,14 38,16.4670128 38,19.5 C38,22.5329872 40.69145,25 43.999636,25 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9667372,44.1083718 L53.3732385,28.4775214 C53.111699,27.0388446 51.8494803,26 50.353392,26 L36.6461915,26 C35.1492202,26 33.8871487,27.0388446 33.6253148,28.4775214 L29.0313745,44.1083718 C28.9870732,44.2578055 28.9908999,44.4102595 29.0352012,44.5484749 C29.0120939,44.692587 29.0004666,44.8292204 29.0004666,44.9667166 C29.0004666,46.6238629 30.3799881,47.9722179 32.0769775,47.9722179 C33.5596724,47.9722179 34.8293973,46.9365374 35.0835777,45.5720741 L37.0669802,38.3758135 L33.7866245,53.9095823 C33.6426821,54.2654042 33.5701222,54.6374783 33.5701222,55.017175 C33.5701222,56.6743213 34.949938,58.0228202 36.6469274,58.0228202 L36.9814684,58.0228202 L36.9814684,70.995074 C36.9814684,72.6530832 38.3612842,74 40.0575377,74 C41.7533497,74 43.1333127,72.651645 43.1333127,70.995074 L43.1333127,58.0228202 L43.8684786,58.0228202 L43.8684786,70.995074 C43.8684786,72.6530832 45.248,74 46.9442535,74 C48.6405071,74 50.0204701,72.651645 50.0204701,70.995074 L50.0204701,58.0228202 L50.3557469,58.0228202 C52.0520005,58.0228202 53.4312275,56.6743213 53.4312275,55.017175 C53.4312275,54.634458 53.3585204,54.2628154 53.2144309,53.9080002 L49.9358414,38.3750944 L51.9033483,45.5102295 C52.1718053,46.9365374 53.4424132,47.9722179 54.9249609,47.9722179 C56.6207729,47.9722179 58,46.6238629 58,44.9667166 C58,44.8300833 57.9879312,44.6911488 57.9652654,44.5476119 C58.007359,44.4093965 58.0111857,44.2578055 57.9667372,44.1083718 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMujeresAdultas, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/MujeresAdultas.ce3cb9b9.svg";
export { ForwardRef as ReactComponent };